import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const classes = {
  input: css`
    margin-bottom: ${spacing(2)};
  `,
  modalBody: css`
    padding: ${spacing(2)};
  `,
  button: css`
    margin-top: ${spacing(2)};
    width: 360px;
  `,
}
